/**
 * Nová verzia appky po nasadení (KOLO 216).
 *
 * Karta otvorená pred nasadením beží na starom kóde, kým ju niekto
 * neobnoví — a starý kód môže posielať to, čo nový server chápe inak.
 * Presne tak vzniklo „v tabuľke 1 ks, cenu bral za 2": stará bunka Ks
 * vlastnej položky posielala `pocet_ks`, server od KOLA 211 z neho robí
 * množstvo a Ks drží na 1.
 *
 * Vite dáva hlavnému skriptu meno s hashom (`/assets/index-i9SFlj88.js`).
 * Stačí stiahnuť `/` a porovnať ho s tým, ktorý beží — keď sa líšia, je
 * nasadená nová verzia. V dev režime je skript `/src/main.tsx` stále ten
 * istý, takže pás sa neukáže.
 */

const SKRIPT = /<script[^>]*type="module"[^>]*src="([^"]+)"/i;

/** Hlavný skript z HTML stránky — `null`, keď tam nie je. */
export function skriptZHtml(html: string): string | null {
  return SKRIPT.exec(html)?.[1] ?? null;
}

/** Hlavný skript, ktorý beží v tejto karte. */
export function bezaciSkript(doc: Document = document): string | null {
  const el = doc.querySelector<HTMLScriptElement>('script[type="module"][src]');
  return el?.getAttribute("src") ?? null;
}

/**
 * Je na serveri iná verzia, než beží? Výpadok siete či odpoveď bez skriptu
 * nie je nová verzia — pás by inak svietil pri každom zlom pripojení.
 */
export async function jeNovaVerzia(
  bezi: string | null = bezaciSkript(),
  stiahni: (url: string) => Promise<string> = async (url) => {
    const r = await fetch(url, {
      cache: "no-store",
      credentials: "same-origin",
    });
    if (!r.ok) throw new Error(String(r.status));
    return r.text();
  },
): Promise<boolean> {
  if (!bezi) return false;
  try {
    const naServeri = skriptZHtml(await stiahni("/"));
    return naServeri !== null && naServeri !== bezi;
  } catch {
    return false;
  }
}
